import axios from "./axios";

export const getRegions = async () => {
  try {
    const data = await axios.get("/api/v1/provision/util?op=list.regions");
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getAZ = async (region_name) => {
  const data = await axios.get(
    `/api/v1/provision/util?op=list.available.zones&region=${region_name}`,
  );
  return data;
};

export const getAddons = async () => {
  try {
    const data = await axios.get(
      `/api/v1/provision/addon`,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const validateInstanceDomainNameUtil = async (domain) => {
  try {
    const data = await axios.post("/api/v1/provision/util?op=validate.domain", {
      domain,
    });
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getNodegroupContext = async () => {
  const data = await axios.get("/api/v1/provision/util?op=context");
  return data;
};

export const getPoolClusters = async (zone_name) => {
  try {
    const data = await axios.get(
      `/api/v1/provision/util?op=list.available.pool.clusters&zone=${zone_name}`,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getInstanceTemplate = async (type) => {
  try {
    const data = await axios.get(
      `/api/v1/provision/util?op=get.instance.profile&profile=${type}`,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};

export const getMachineTypes = async (type) => {
  try {
    const data = await axios.get(
      `/api/v1/provision/eks?op=getMachineTypes&region=${type}`,
    );
    return data;
  } catch (error) {
    return { status: "error", error };
  }
};
